import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModuleAccessService } from '../services/module-access.service';

export const moduleAccessGuard: CanActivateFn = (route) => {
  const moduleAccessService = inject(ModuleAccessService);
  const router = inject(Router);

  const moduleCode = route.data?.['module'] as string | undefined;
  if (!moduleCode) {
    return true;
  }

  if (moduleAccessService.hasModule(moduleCode)) {
    return true;
  }

  router.navigate(['/app/dashboard']);
  return false;
};
